import React, { Suspense } from 'react';
import SEOMetadata from '@/components/SEOMetadata';
import SpiralHeader from '@/components/landing/developers/SpiralHeader'
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadFeatureGrid = () => import('@/components/landing/developers/FeatureGrid');
const FeatureGrid = React.lazy(loadFeatureGrid);
const loadFeatureCards = () => import('@/components/landing/home/FeatureCards');
const FeatureCards = React.lazy(loadFeatureCards);
const loadCodeInplace = () => import('@/components/landing/developers/CodeInplace');
const CodeInplace = React.lazy(loadCodeInplace);
const loadIntergrationCards = () => import('@/components/landing/developers/IntergrationCards');
const IntergrationCards = React.lazy(loadIntergrationCards);
const loadFeatureWall = () => import('@/components/landing/developers/FeatureWall');
const FeatureWall = React.lazy(loadFeatureWall);
const loadPricingTable = () => import('@/components/landing/PricingTable');
const PricingTable = React.lazy(loadPricingTable);
const loadGetStarted = () => import('@/components/landing/GetStarted');
const GetStarted = React.lazy(loadGetStarted);
const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);

const LibrariesPage: React.FC = () => {
  useIdlePrefetch([loadFeatureGrid, loadFeatureCards, loadCodeInplace, loadIntergrationCards, loadFeatureWall, loadPricingTable, loadGetStarted, loadFooter]);
  return (
    <div>
      <SEOMetadata
        title="Financial Data SDKs: Python, JavaScript & C"
        description="Official Python financial data SDK and TypeScript financial API clients for market data, financial analytics, and algorithmic trading."
        canonicalUrl="https://axionquant.com/developers/libraries"
      />

      <SpiralHeader/>

      <FeatureGrid/>
      <FeatureCards/>

      <Suspense fallback={null}>
      <CodeInplace />
      <IntergrationCards/>
      <FeatureWall/>

      <PricingTable />

      <GetStarted />

      <Footer />
      </Suspense>
    </div>
  );
};

export default LibrariesPage;
